import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import SubadminListLayer from "../../components/SubadminListLayer";

const SubadminListPage = () => {
  return (
    <>
      <MasterLayout>
        <Breadcrumb title="Subadmin List" />
        <SubadminListLayer />
      </MasterLayout>
    </>
  );
};

export default SubadminListPage;

